import React, { FC, useState } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

import { Auth } from '../../helpers/Auth';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const SignUp: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const classes = useStyles();

  const [name, setName] = useState('');
  const [surname, setSurname] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [partnerCode, setPartnerCode] = useState('');
  const [response, setResponse] = useState<null | string>(null);

  const handleSignUp = () => {
    if (password === confirmPassword) {
      Auth.signUp(email, email, password, name, surname, phone, partnerCode)
        .then(() => {
          navigate(location.state?.from?.pathname || '/');
        })
        .catch((reason) => {
          if (typeof reason.response.data.message === 'string') {
            setResponse(reason.response.data.message);
          } else {
            setResponse(reason.response.data.message[0].messages[0].message || 'Errore nella richiesta.');
          }
        });
    } else {
      setResponse('Le due password non coincidono.');
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="h1" variant="h5">
          Registrati
        </Typography>
        <form className={classes.form} noValidate>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                autoComplete="name"
                name="name"
                variant="outlined"
                required
                fullWidth
                label="Nome"
                autoFocus
                onChange={(event) => setName(event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                autoComplete="surname"
                name="surname"
                variant="outlined"
                required
                fullWidth
                label="Cognome"
                onChange={(event) => setSurname(event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                label="Email"
                name="email"
                autoComplete="email"
                onChange={(event) => setEmail(event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                label="Telefono"
                name="phone"
                autoComplete="phone"
                onChange={(event) => setPhone(event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                onChange={(event) => setPassword(event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="confirmPassword"
                label="Conferma password"
                type="password"
                id="confirmPassword"
                onChange={(event) => setConfirmPassword(event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                fullWidth
                name="partnerCode"
                label="Codice partner"
                id="partnerCode"
                onChange={(event) => setPartnerCode(event.target.value)}
              />
            </Grid>
          </Grid>
          <Button fullWidth variant="contained" color="primary" className={classes.submit} onClick={handleSignUp}>
            Registrati
          </Button>
          <Grid container justify="flex-end" spacing={2}>
            {response && (
              <Grid item xs={12} style={{ color: 'red', fontWeight: 'bold' }}>
                {response}
              </Grid>
            )}
            <Grid item xs={12}>
              <Link to="/signin" variant="body2" component={RouterLink}>
                Hai già un account? Fai il login
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>
    </Container>
  );
};

export default SignUp;
